module.exports = __webpack_public_path__ + "media/images/strategic-partners/new/Spruce-ba9deae3fc13bd55dc3cd96615200953.png";